(() => {
  const KEY = "nj_wishlist_handles"; // localStorageキー
  const ATTR_KEY = "wishlist";       // cart attributesキー

  // ---------------------------
  // Utils
  // ---------------------------
  const uniq = (arr) => Array.from(new Set(arr));

  const loadLocal = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };

  const saveLocal = (list) => {
    localStorage.setItem(KEY, JSON.stringify(list));
  };

  const normalize = (list) => uniq((list || []).map(String).map(s => s.trim()).filter(Boolean));

  const setBtnState = (btn, isActive) => {
    btn.classList.toggle("is-active", isActive);
    btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    const icon = btn.querySelector(".wishlist-btn__icon");
    if (icon) icon.textContent = isActive ? "♥" : "♡";
  };

  const syncButtons = (list) => {
    const set = new Set(list);
    document.querySelectorAll(".js-wishlist-btn").forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      setBtnState(btn, set.has(handle));
    });
  };

const updateHeaderCount = (list) => {
  const countEl = document.querySelector("[data-wishlist-count]");
  if (!countEl) return;

  const link = countEl.closest("a.header__icon--wishlist");
  const count = Array.isArray(list) ? list.length : 0;

  // 0件ならバッジもリンクも非表示（数字が出続けるのを防ぐ）
  if (count <= 0) {
    countEl.textContent = "";
    countEl.hidden = true;
    countEl.style.display = "none";     // ★hiddenが効かないテーマでも確実に消す
    if (link) link.hidden = true;
    if (link) link.style.display = "none";
    return;
  }

  // 1件以上なら表示
  countEl.textContent = String(count);
  countEl.hidden = false;
  countEl.style.display = "";           // 表示に戻す
  if (link) link.hidden = false;
  if (link) link.style.display = "";
};

  // ---------------------------
  // Cart attributes mirror
  // ---------------------------
  const syncToCartAttributes = async (list) => {
    const value = list.join(",");
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { [ATTR_KEY]: value } }),
    });
  };

  const restoreFromCartAttributes = async () => {
    const local = loadLocal();
    if (local.length) return local;

    const res = await fetch("/cart.js", { method: "GET" });
    const cart = await res.json();
    const attr = cart?.attributes?.[ATTR_KEY];
    if (!attr) return [];

    const restored = normalize(attr.split(","));
    saveLocal(restored);
    return restored;
  };

  // ---------------------------
  // Toggle / Remove
  // ---------------------------
  const toggle = (handle) => {
    const h = String(handle).trim();
    let list = loadLocal();
    if (list.includes(h)) list = list.filter((x) => x !== h);
    else list = [h, ...list];
    list = normalize(list);
    saveLocal(list);
    return list;
  };

  const remove = (handle) => {
    const h = String(handle).trim();
    const list = normalize(loadLocal().filter((x) => x !== h));
    saveLocal(list);
    return list;
  };

  // ---------------------------
  // Wishlist page rendering (ONLY if #wishlist-view exists)
  // ---------------------------
  const hasWishlistView = () => !!document.getElementById("wishlist-view");

  const escapeHtml = (str) =>
    String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const renderWishlistPage = async (list) => {
    const root = document.getElementById("wishlist-view");
    if (!root) return; // wishlistページ以外は動かさない

    if (!list.length) {
      root.innerHTML = `<p>お気に入りに追加した商品はまだありません。</p>`;
      return;
    }

    root.innerHTML = `<p>読み込み中...</p>`;

    const cards = [];
    for (const handle of list) {
      try {
        const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { method: "GET" });
        if (!res.ok) throw new Error("fetch failed");
        const product = await res.json();

        const title = escapeHtml(product.title);
        const url = `/products/${product.handle}`;
        const img = product.featured_image
          ? `<img src="${product.featured_image}" alt="${title}" loading="lazy">`
          : "";

        cards.push(`
          <div class="wishlist-item" data-wishlist-item="${escapeHtml(product.handle)}">
            <a class="wishlist-link" href="${url}">
              ${img}
              <h3 class="wishlist-title">${title}</h3>
            </a>
            <button type="button" class="wishlist-remove" data-remove-handle="${escapeHtml(product.handle)}">
              削除
            </button>
          </div>
        `);
      } catch (e) {
        // 取得失敗した場合でも落とさない（壊れたハンドル等）
        cards.push(`
          <div class="wishlist-item">
            <div class="wishlist-link">
              <h3 class="wishlist-title">${escapeHtml(handle)}</h3>
              <p style="margin:6px 0 0; font-size:12px; opacity:.7;">商品情報を取得できませんでした</p>
            </div>
            <button type="button" class="wishlist-remove" data-remove-handle="${escapeHtml(handle)}">
              削除
            </button>
          </div>
        `);
      }
    }

    root.innerHTML = `<div class="wishlist-grid">${cards.join("")}</div>`;
  };

  // ---------------------------
  // Apply state everywhere
  // ---------------------------
  const applyState = (list, { syncCart = false, renderPage = false } = {}) => {
    const normalized = normalize(list);
    syncButtons(normalized);
    updateHeaderCount(normalized);

    if (syncCart) {
      syncToCartAttributes(normalized).catch(() => {});
    }
    if (renderPage && hasWishlistView()) {
      renderWishlistPage(normalized).catch(() => {});
    }

    // 必要なら他スクリプトへ通知
    document.dispatchEvent(new CustomEvent("wishlist:updated", { detail: { list: normalized } }));

    return normalized;
  };

  // ---------------------------
  // Init
  // ---------------------------
  const init = async () => {
    const list = await restoreFromCartAttributes().catch(() => loadLocal());
    applyState(list, { syncCart: false, renderPage: true });
  };

  // ---------------------------
  // Events
  // ---------------------------
  document.addEventListener("click", (e) => {
    // wishlistページの削除ボタン
    const removeBtn = e.target.closest(".wishlist-remove");
    if (removeBtn) {
      const handle = removeBtn.dataset.removeHandle;
      if (!handle) return;

      const list = remove(handle);
      applyState(list, { syncCart: true, renderPage: true });
      return;
    }

    // 商品カード/商品詳細の♡ボタン
    const btn = e.target.closest(".js-wishlist-btn");
    if (!btn) return;

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    const list = toggle(handle);
    applyState(list, { syncCart: true, renderPage: true });
  });

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init); // テーマエディタの再描画対策

})();